import { PopupInterface } from 'common/types/entities/popup-interface'
import { mobilePaddingsCss, paddingsCss } from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

type PopupScrollContentUiProps = Pick<
  PopupInterface,
  'padding' | 'mobilePadding'
>

export const PopupScrollContentUi = styled.div<PopupScrollContentUiProps>`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: inherit;

  ${paddingsCss}

  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobilePaddingsCss}
    `}
`
